<template>
  <div class="em-year">
    <date-picker
      :value="pickerValue"
      type="year"
      placeholder="Todos los años"
      :editable="false"
      :clearable="false"
      :open="open"
      :lang="lang"
      popup-class="em-year-popup"
      :disabled-date="isDisabled"
      @open="open = true"
      @close="open = false"
      @change="onChange"
    >
      <template v-slot:header="{ emit }">
        <button
          type="button"
          class="mx-btn mx-btn-text em-year-all"
          :class="{ 'is-active': !year }"
          @click="selectAllYears(emit)"
        >
          Todos los años
        </button>
      </template>
    </date-picker>
    <i class="material-icons em-year-icon" @click="open = true">event</i>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import es from "vue2-datepicker/locale/es";
import "vue2-datepicker/index.css";
import { isYearDisabled } from "../helpers";

export default {
  name: "YearPicker",
  components: { DatePicker },
  props: {
    year: {
      type: Number,
      default: null,
    },
    rangeDates: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      open: false,
      lang: es,
    };
  },
  computed: {
    pickerValue() {
      return this.year ? new Date(this.year, 0, 1) : null;
    },
  },
  methods: {
    isDisabled(date) {
      return isYearDisabled(date, this.rangeDates, new Date());
    },
    onChange(date) {
      this.$emit("change", date ? date.getFullYear() : null);
    },
    selectAllYears(emit) {
      emit(null);
      this.open = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/empresas/components/YearPicker.vue